module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showStepper) ? _c('div', {
    staticClass: "stepper-container"
  }, [_c('div', {
    staticClass: "step",
    class: {
      selected: _vm.currentStep >= 0
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDonation),
      expression: "isDonation"
    }],
    staticClass: "step",
    class: {
      selected: _vm.currentStep >= 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      selected: _vm.currentStep >= 2
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 0) ? _c('LeafReliefDetails', {
    attrs: {
      "petitionSelector": _vm.petitionSelector,
      "donationSelector": _vm.donationSelector,
      "petitionHandle": _vm.petitionHandle,
      "programName": _vm.programName,
      "datalayerName": _vm.datalayerName,
      "duplicateEmailMessage": _vm.duplicateEmailMessage,
      "sendToIve": _vm.sendToIve,
      "iveSupplier": _vm.iveSupplier,
      "iveSource": _vm.iveSource,
      "isSpeciesForm": _vm.isSpeciesForm
    },
    on: {
      "next": function($event) {
        _vm.next(0)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 1) ? _c('Payment', {
    attrs: {
      "datalayerName": _vm.datalayerName
    },
    on: {
      "next": function($event) {
        _vm.next(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('ThankYou', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }],
    attrs: {
      "thankYouText": _vm.thankYouText,
      "getSocialText": _vm.getSocialText
    },
    on: {
      "next": function($event) {
        _vm.next(2)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ad51c86","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/leaf-relief/Stepper.vue
// module id = 790
// module chunks = 0